import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import { Icon } from "../../../icons/icons";
import DefaultCurrencyFormat from "../../DefaultCurrencyFormat";
import Remote from "../../LoaderRemote";
import GuestModals from "./GuestModals";
import { BsCheckCircle } from "@react-icons/all-files/bs/BsCheckCircle";
import { useTranslation } from "../../../context/TranslationContext";
import Local from "../../ImageLoader";
import { FaRegImages } from "@react-icons/all-files/fa/FaRegImages";
import dynamic from "next/dynamic";
const Fancybox = dynamic(() => import("../../Fancybox.js"));
const ReservationItem = ({ data, ssr, auth, datax, list }) => {
  const {
    ReservationStatus0,
    ReservationStatus1,
    ReservationStatus1ActionBtn,
    ReservationStatus1ActionCompleted,
    ReservationStatus1ActionBtn2,
    ReservationStatus3,
    ReservationStatus3Text,
    ReservationStatus3ActionBtn,
    ReservationStatus3ActionBtn2,
    ReservationStatus3ActionBtn2Completed,
    ReservationStatus4,
    reservationNo,
    reservationDate,
    reservationCustomerName,
    reservationDate1,
    reservationDate2,
    reservationtionPrice,
    paymentMethod1Title,
    paymentMethod2Title,
    person,
    bedRoom,
    bathRoom,
  } = useTranslation();

  const [guestModal, setGuestModal] = useState(false);
  const [guestLoading, setguestLoading] = useState(true);
  const [open, setOpen] = useState(false);

  const PhotosWithoutCover = data?.photos;

  const ReservationStatus = {
    0: {
      text: ReservationStatus0,
      statusBtn: (
        <div className="flex items-center py-[6px] px-[10px] rounded bg-slate-300">
          <Icon name={"wheltime"}></Icon>
          <span className="font-bold text-[10px] leading-[14px] ml-[10px] text-white">
            {ReservationStatus0}
          </span>
        </div>
      ),
    },
    1: {
      text: ReservationStatus1,
      statusBtn: (
        <div className="flex items-center py-[6px] px-[10px] rounded bg-[#FC833F]">
          <Icon name={"wheltime"}></Icon>
          <span className="font-bold text-[10px] leading-[14px] ml-[10px] text-white">
            {ReservationStatus1}
          </span>
        </div>
      ),
      actionBtnTop:
        data.odeme == 2 ? (
          process.env.NEXT_PUBLIC_SITE == 3 ? (
            data.ToplamHavale == "0" ? (
              <Link
                href={`/${ssr.result.BankTransferPage.url}?_=${data.hashed}`}
              >
                <a className="flex items-center text-information-color2 xl:ml-0 ml-auto">
                  <Icon name={"problemreport"}></Icon>
                  <span className="text-[12px] font-bold  leading-4 ml-4 border-b border-information-color2">
                    {ReservationStatus1ActionBtn}
                  </span>
                </a>
              </Link>
            ) : (
              <span className="flex items-center text-information-color2 xl:ml-0 ml-auto">
                <BsCheckCircle size={24} />
                <span className="text-[12px] font-bold  leading-4 ml-1 border-b border-information-color2">
                  {ReservationStatus1ActionCompleted}
                </span>
              </span>
            )
          ) : (
            <>
              <Link
                href={`/${ssr.result.BankTransferPage.url}?_=${data.hashed}`}
              >
                <a className="text-white px-[17px] mb-2 xl:mb-0 xl:mr-1 mr-0 xl:w-auto w-full  py-[10px]  duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] focus:ring-4 focus:outline-none focus:ring-blue-300  font-medium rounded-lg text-sm  text-center ">
                  {paymentMethod1Title}
                </a>
              </Link>
            </>
          )
        ) : (
          ""
        ),
      actionBtn:
        data.odeme == 1 ? (
          <>
            <Link href={`/${ssr.result.PaymentPage.url}?_=${data.hashed}`}>
              <a className="text-white px-[17px] mb-2 xl:mb-0 xl:mr-1 mr-0 xl:w-auto w-full  py-[10px]  duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] focus:ring-4 focus:outline-none focus:ring-blue-300  font-medium rounded-lg text-sm  text-center ">
                {paymentMethod2Title}
              </a>
            </Link>
          </>
        ) : (
          ""
        ),
    },
    3: {
      text: ReservationStatus3,
      statusBtn: (
        <div className="flex items-center py-[6px] px-[10px] rounded bg-green-500">
          <span className="font-bold text-[10px] leading-[14px] text-white">
            {ReservationStatus3Text}
          </span>
        </div>
      ),
      actionBtnTop:
        data.odeme == 2 ? (
          <button className="flex items-center text-[#0176AB] xl:ml-0 ml-auto">
            <Icon name={"problemreport"}></Icon>
            <span className="text-[12px] font-bold  leading-4 ml-4 border-b border-[#0176ab]">
              {ReservationStatus3ActionBtn}
            </span>
          </button>
        ) : (
          ""
        ),
      actionBtn:
        data.ToplamKisiBilgisi == 0 ? (
          <button
            type="button"
            onClick={() => {
              setGuestModal(data.hashed);
              setOpen(true);
            }}
            disabled={guestLoading}
            className="text-white xl:w-auto w-full  px-[17px]  py-[10px]   duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb]  rounded text-[12px] font-bold  "
          >
            {ReservationStatus3ActionBtn2}
          </button>
        ) : (
          <button
            type="button"
            className="text-white xl:w-auto w-full  px-[17px]  py-[10px] duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb]  rounded text-[12px] font-bold"
          >
            {ReservationStatus3ActionBtn2Completed}
          </button>
        ),
    },
    4: {
      text: { ReservationStatus4 },
      statusBtn: (
        <div className="flex items-center py-[6px] px-[10px] rounded bg-red-500">
          <span className="font-bold text-[10px] leading-[14px] text-white">
            {ReservationStatus4}
          </span>
        </div>
      ),
    },
  };
  return (
    <div className="flex items-center flex-wrap border-2 border-[#EDF6FB] rounded-[10px] p-[17px] duration-200 hover:border-[#00BBC0] mb-4">
      <div className="relative lg:w-[264px] w-full xl:h-[173px] h-[200px] rounded xl:mr-[43px] lg:mr-7 lg:mb-0 mb-5 flex-shrink-0">
        <Image
          src={data.resim}
          layout={"fill"}
          sizes="
              (max-width: 640) 70vw,
              (max-width: 1024) 100vw,
              260px"
          loader={Remote}
          objectFit={"cover"}
          alt={data.title}
        />
        <div className="absolute top-1 right-1">
          <Fancybox options={{ infinite: false }}>
            <button
              type="button"
              className={`text-white px-[17px] mb-2 xl:mb-0 xl:mr-1 mr-0 xl:w-auto w-full  py-[10px]  duration-200 bg-black/50 focus:outline-none  font-medium rounded-lg text-sm  text-center`}
              data-fancybox="galleryM"
              data-src={
                process.env.NEXT_PUBLIC_CDN +
                "/uploads/" +
                PhotosWithoutCover[0].Filename
              }
              data-thumb={
                process.env.NEXT_PUBLIC_CDN +
                "/uploads/150/" +
                PhotosWithoutCover[0].Filename
              }
            >
              <FaRegImages size={24} />
            </button>
          </Fancybox>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 flex justify-between items-center">
          <div className="flex items-center text-center">
            <div className="flex flex-col ml-3">
              <span className="text-white text-sm font-semibold">
                {data.kisi}
              </span>
              <span className="text-white/80 text-xs">{person}</span>
            </div>
          </div>
          <div className="flex items-center text-center">
            <div className="flex flex-col ml-3">
              <span className="text-white text-sm font-semibold">
                {data.yatak_odasi}
              </span>
              <span className="text-white/80 text-xs">{bedRoom}</span>
            </div>
          </div>
          <div className="flex items-center text-center">
            <div className="flex flex-col ml-3">
              <span className="text-white text-sm font-semibold">
                {data.banyo}
              </span>
              <span className="text-white/80 text-xs">{bathRoom}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col flex-1">
        <div className="flex  xl:flex-row flex-col justify-between xl:mb-1 mb-5 xl:order-1 order-2">
          <div className="flex items-center xl:justify-start justify-between xl:mb-0 mb-1 flex-col sm:flex-row">
            <div className="flex items-center sm:mr-9">
              <span className="font-semibold text-13 leading-[18px] text-dark ">
                {reservationNo} :
              </span>
              <span className="font-semibold text-13 leading-[18px] text-dark border-b">
                {data.id}
              </span>
            </div>
            <div className="font-semibold text-13 text-[#A1B2B8] leading-[18px]">
              {reservationDate} :{data.islem_tarihi}
            </div>
          </div>
          {ReservationStatus[data.Durum]?.actionBtnTop}
        </div>
        <div className="flex items-center xl:justify-start justify-between xl:mb-10 mb-1 xl:order-2 order-1 flex-col sm:flex-row">
          <span className="text-[23px] font-semibold text-dark leading-[31px] mr-3">
            {data.baslik}
          </span>
          <div className="flex items-center space-x-3">
            {ReservationStatus[data.Durum]?.statusBtn}
          </div>
        </div>
        <div className="flex items-end justify-between order-3 xl:flex-nowrap flex-wrap">
          <div className="flex lg:mb-0 mb-2 lg:w-auto w-full flex-col text-center sm:flex-row sm:text-left">
            <div className="flex flex-col md:mr-20 sm:mr-9 flex-auto">
              <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mb-2">
                {reservationCustomerName}
              </span>
              <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark mb-2">
                {data.musteri}
              </span>
            </div>
            <div className="flex flex-col md:mr-20 sm:mr-9 flex-auto">
              <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mb-2">
                {reservationDate1}
              </span>
              <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark mb-2">
                {data.tarih}
              </span>
            </div>
            <div className="flex flex-col md:mr-20 sm:mr-9 flex-auto">
              <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mb-2">
                {reservationDate2}
              </span>
              <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark mb-2">
                {data.tarih2}
              </span>
            </div>
            <div className="flex flex-col md:mr-20 sm:mr-9 flex-auto">
              <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-[#A1B2B8] mb-2">
                {reservationtionPrice}
              </span>
              <span className="font-semibold 2xl:text-13 text-[11px] 2xl:leading-[18px] leading-[14px] text-dark mb-2">
                <DefaultCurrencyFormat
                  value={data.tutar}
                  Symbol={data.Symbol}
                ></DefaultCurrencyFormat>
              </span>
            </div>
          </div>
          <div className="flex flex-col">
            {ReservationStatus[data.Durum]?.actionBtn}
          </div>
          {/* <button
            type="button"
            className="text-white px-[17px] xl:w-auto w-full  py-[10px]  duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] focus:ring-4 focus:outline-none focus:ring-blue-300  font-medium rounded-lg text-sm  text-center "
          >
            Ödeme Yap
          </button> */}
        </div>
        <GuestModals
          guestModal={guestModal}
          data={auth}
          setguestLoading={setguestLoading}
          setGuestModal={setGuestModal}
          setOpen={setOpen}
          open={open}
          rez={data}
          list={list}
        />
      </div>
      {data?.yasakli == "1" && (
        <div className="w-full mt-4">
          <div
            dangerouslySetInnerHTML={{ __html: data?.icerik }}
            className="text-sm text-[#4A5568] leading-6 prose prose-sm max-w-none prose-headings:text-dark prose-headings:font-semibold prose-p:my-2 prose-ul:my-2 prose-li:my-1 prose-strong:text-dark prose-strong:font-semibold prose-a:text-[#00BBC0] prose-a:no-underline hover:prose-a:underline"
          ></div>
        </div>
      )}

      <div className="hidden">
        {PhotosWithoutCover?.map((item, key) => {
          return (
            <Fancybox options={{ infinite: false }} key={key}>
              <div
                className="w-full h-full relative"
                data-fancybox="galleryM"
                data-src={
                  process.env.NEXT_PUBLIC_CDN + "/uploads/" + item.Filename
                }
                data-thumb={
                  process.env.NEXT_PUBLIC_CDN + "/uploads/150/" + item.Filename
                }
              ></div>
            </Fancybox>
          );
        })}
      </div>
    </div>
  );
};

export default ReservationItem;
